export default "__VITE_ASSET__BcRm9ArZ__"